var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMusicalNoteIco(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.048 2.2a.774.774 0 0 0-.942-.737L11.36 4.969a.77.77 0 0 0-.43.251.77.77 0 0 0-.19.518v.001l.227 17.088a4.358 4.358 0 1 0 1.591 3.245l-.222-16.825 14.216-3.168.177 13.293a4.358 4.358 0 1 0 1.591 3.235l-.231-17.44a.798.798 0 0 0 .002-.063L28.07 3.64l-.019-1.377a.76.76 0 0 0-.003-.063Z",
    fill: "#FFDCA8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusicalNoteIco);
export default __webpack_public_path__ + "static/media/musical-note_ico.fc9d4a8c03cd5ac9fc5e840ff503b5b4.svg";
export { ForwardRef as ReactComponent };